module.exports = __webpack_public_path__ + "img/card.e5542f66.png";